import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useEffect } from 'react';
import { authApi } from '@/api/authApi';
const AuthContext = createContext(undefined);
export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within AuthProvider');
    }
    return context;
};
export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        const initAuth = async () => {
            if (authApi.isAuthenticated()) {
                try {
                    const currentUser = await authApi.getCurrentUser();
                    setUser(currentUser);
                }
                catch (error) {
                    console.error('Failed to fetch current user:', error);
                    localStorage.removeItem('auth_tokens');
                }
            }
            setIsLoading(false);
        };
        initAuth();
    }, []);
    const login = async (email, password) => {
        const response = await authApi.login({ email, password });
        if (response.requires2FA) {
            return { requires2FA: true, userId: response.userId };
        }
        setUser(response.user);
        return {};
    };
    const complete2FALogin = async (userId, token) => {
        const response = await authApi.complete2FALogin(userId, token);
        setUser(response.user);
    };
    const signup = async (email, password, name) => {
        const response = await authApi.signup({ email, password, name });
        setUser(response.user);
    };
    const logout = async () => {
        await authApi.logout();
        setUser(null);
    };
    return (_jsx(AuthContext.Provider, { value: {
            user,
            isAuthenticated: !!user,
            isLoading,
            login,
            complete2FALogin,
            signup,
            logout,
        }, children: children }));
};
